import React from 'react';
import LookupAutocomplete from '../../../../../Components/Controls/LookupAutocomplete/LookupAutocomplete';
import {
  ChangePublishStatus,
  UpdateOfferStatus,
} from '../../../../../Services';
import { showError } from '../../../../../Helper';
import {
  SelectComponet,
  SwitchComponent,
} from '../../../../../Components';
import { TableFilterTypesEnum } from '../../../../../Enums';

function formatDay(count) {
  if (!count) return '';
  const pluralRules = new Intl.PluralRules('en');
  const pluralForm = pluralRules.select(count);
  const suffix = pluralForm === 'one' ? 'day' : 'days';
  return `${count} ${suffix}`;
}

export const headerData = (t, reload, offerStatus) => [
  {
    label: 'offer_name',
    input: 'offerName',
  },
  {
    label: 'vendor_name',
    input: 'vendorName',
    isSortable: true,
  },
  {
    label: 'category',
    input: 'category',
    component: (row) =>
      row.vendorServiceCategoryNames?.[0]?.offerServiceCategoryName,
  },
  {
    label: 'service',
    input: 'vendorServiceName',
  },
  {
    label: 'start_date',
    input: 'offerStartDate',
    isSortable: true,
    isDate: true,
    filterType: TableFilterTypesEnum.datePicker.key,
  },
  {
    label: 'end_date',
    input: 'offerEndDate',
    isDate: true,
    isHiddenFilter: true,
  },
  {
    label: 'duration',
    input: 'offerDuration',
    component: (row) => formatDay(row.offerDuration),

    isHiddenFilter: true,
  },
  {
    label: 'qr_code',
    input: 'qrCode',
  },
  {
    label: 'offer_availability',
    input: 'offerAvailableName',
  },
  {
    label: 'interested_clients',
    input: 'numberOfInterestedClients',
    isSortable: true,
  },
  {
    label: 'discount',
    input: 'discountPercentage',
    isSortable: true,
    component: (row) => `${row.discountPercentage}%`,
    filterType: TableFilterTypesEnum.numberInput.key,
  },
  {
    label: 'discount_type',
    input: 'discountType',
    hideComponentFilter: true,
    component: (row) => (
      <span>
        {row.discountType === 1
          ? t('maximum_amount')
          : row.discountType === 2
          ? t('fixed_amount')
          : ''}
      </span>
    ),
  },
  {
    label: 'promo_code',
    input: 'promoCode',
  },
  {
    label: 'published_date',
    input: 'publishedDate',
    isSortable: true,
    isDate: true,
    filterType: TableFilterTypesEnum.datePicker.key,
  },
  {
    label: 'status',
    input: 'offerStatusName',
    hideComponentFilter: true,
    component: (row, _rowIndex) => (
      <SelectComponet
        data={offerStatus}
        value={row.offerStatusId}
        textInput={'lookupItemName'}
        valueInput={'lookupItemId'}
        onSelectChanged={async (value) => {
          {
            try {
              await UpdateOfferStatus({
                offerId: row.vendorOfferId,
                offerStatusId: value,
              });
              reload();
            } catch (error) {
              showError(t('something_went_wrong'));
            }
          }
        }}
      />
    ),
  },
  {
    label: 'published',
    input: 'published',
    hideComponentFilter: true,
    component: (row, _rowIndex) => (
      <SwitchComponent
        label={row.isPublishOffer ? 'published' : 'unpublished'}
        isChecked={row.isPublishOffer}
        isDisabled={!(row.offerStatusName.toLowerCase() === 'active')}
        onChangeHandler={async (_e, checked) => {
          try {
            await ChangePublishStatus({
              offerId: row.vendorOfferId,
              isPublished: checked,
            });
            reload();
          } catch (error) {
            showError(t('something_went_wrong'));
          }
        }}
      />
    ),
  },
  {
    label: 'created_by',
    input: 'createdBy',
  },
  {
    label: 'created_date',
    input: 'createdOn',
    isDate: true,
    filterType: TableFilterTypesEnum.datePicker.key,
  },
  {
    label: 'Company Name',
    input: 'holdingCompanyName',
    isSortable: true,
  },
];

export const filterData = (t, updateFilter) => [
  {
    label: 'offer_name',
    input: 'offerName',
  },
  {
    label: 'vendor_name',
    input: 'vendorName',
  },
  {
    label: 'category',
    input: 'serviceCategoryName',
    component: (row) =>
      row.vendorServiceCategoryNames?.[0]?.offerServiceCategoryName,
  },
  {
    label: 'service',
    input: 'vendorServiceName',
    isHiddenFilter: true,
  },
  {
    label: 'start_date',
    input: 'offerStartDate',
    isDate: true,
    filterType: TableFilterTypesEnum.datePicker.key,
  },
  {
    label: 'end_date',
    input: 'offerEndDate',
    isDate: true,
    isHiddenFilter: true,
  },
  {
    label: 'duration',
    input: 'offerDuration',
    isHiddenFilter: true,
  },
  {
    label: 'qr_code',
    input: 'qrCode',
    isHiddenFilter: true,
  },
  {
    label: 'offer_availability',
    input: 'offerAvailableName',
    isHiddenFilter: true,
  },
  {
    label: 'interested_clients',
    input: 'numberOfInterestedClients',
    filterType: TableFilterTypesEnum.numberInput.key,
    positiveNumber: true,
  },
  {
    label: 'discount',
    input: 'discountPercentage',
    filterType: TableFilterTypesEnum.numberInput.key,
  },
  {
    label: 'discount_type',
    input: 'discountType',
    component: (row, _rowIndex) => (
      <SelectComponet
        data={[
          { id: 0, key: t('all'), value: null },
          { id: 1, key: t('maximum_amount'), value: 1 },
          { id: 2, key: t('fixed_amount'), value: 2 },
        ]}
        defaultValue={null}
        textInput={'key'}
        valueInput={'value'}
        onSelectChanged={(value) => {
          updateFilter({ discountType: value });
        }}
      />
    ),
  },
  {
    label: 'promo_code',
    input: 'promoCode',
  },

  {
    label: 'published_date',
    input: 'publishedDate',
    isDate: true,
    filterType: TableFilterTypesEnum.datePicker.key,
  },
  {
    label: 'status',
    input: 'offerStatusName',
    component: () => (
      <LookupAutocomplete
        lookupName={'OfferStatus'}
        onChange={(_e, newValue) => {
          updateFilter({ offerStatusName: newValue?.lookupItemName });
        }}
      />
    ),
  },
  {
    label: 'published',
    input: 'published',
    component: (row, _rowIndex) => (
      <SelectComponet
        data={[
          { id: true, name: 'published' },
          { id: false, name: 'unpublished' },
          { id: null, name: 'all' },
        ]}
        textInput={'name'}
        valueInput={'id'}
        onSelectChanged={(value) => {
          updateFilter({ isPublishOffer: value });
        }}
      />
    ),
  },
  {
    label: 'created_by',
    input: 'createdBy',
  },
  {
    label: 'created_date',
    input: 'createdOn',
    isDate: true,
    filterType: TableFilterTypesEnum.datePicker.key,
  },
  {
    label: 'Company Name',
    input: 'holdingCompanyName',
  },
];
